class Browser {
    constructor() {
        this.ua = navigator.userAgent.toLowerCase();
        this.platform = navigator.platform;
        this.appVersionInfo = navigator.userAgent.match(/SHMApp\/(\d+\.\d+\.\d+)(.*)?@(\d+\.\d+\.\d+)/);
    }
    isSHMApp() {
        return this.ua.indexOf('shmapp') !== -1;
    }
    /**
     * 是否是趣头条App
     */
    isQutoutiaoApp() {
        return this.ua.indexOf('qukan') !== -1;
    }
    isWechat() {
        return this.ua.indexOf('micromessenger') !== -1;
    }
    isWeibo() {
        return this.ua.indexOf('weibo') !== -1;
    }
    isQQ() {
        return this.ua.indexOf('mqqbrowser') > -1;
    }
    isIOS() {
        return /(iphone|ipad|ipod|ios)/.test(this.ua);
    }
    isAndroid() {
        return this.ua.indexOf('android') !== -1;
    }
    isIE() {
        const isIE = this.ua.indexOf('compatible') > -1 && this.ua.indexOf('msie') > -1;
        const isEdge = this.ua.indexOf('edge') > -1 && !isIE;
        const isIE11 = this.ua.indexOf('trident') > -1 && this.ua.indexOf('rv:11.0') > -1;
        return isIE || isEdge || isIE11;
    }
    isChrome() {
        return this.ua.indexOf('chrome') > -1;
    }
    isSafari() {
        return this.ua.indexOf('safari') > -1;
    }
    isMac() {
        return this.platform.indexOf('macintel') > -1;
    }
    isWindows() {
        return this.platform.indexOf('win32') > -1 || this.platform.indexOf('win64') > -1;
    }
    isMobile() {
        return this.isWechat() || this.isWeibo() || this.isQQ() || this.isIOS() || this.isAndroid();
    }
    getSHMAppVersion() {
        var _a, _b;
        return (_b = (_a = this.appVersionInfo) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : '';
    }
    getSHMAppBinaryVersion() {
        var _a, _b;
        return (_b = (_a = this.appVersionInfo) === null || _a === void 0 ? void 0 : _a[3]) !== null && _b !== void 0 ? _b : '';
    }
}
export const browser = new Browser();
